
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual'
 
export function isBeforeOrEqualDate(date) {
    return isBefore(date, new Date()) || isEqual(date, new Date())
  }